export default "__VITE_ASSET__DfmYwDMo__"